/* eslint-disable */
let tools = {}

tools.getWindowSize = () => {
  // @see http://stackoverflow.com/questions/641857/javascript-window-resize-event
  let w = window
  let d = document
  let e = d.documentElement
  let g = d.getElementsByTagName('body')[0]
  let x = w.innerWidth || e.clientWidth || g.clientWidth
  let y = w.innerHeight || e.clientHeight || g.clientHeight
  return {height: y, width: x}
}

tools.isIE = (function () {
  let browser = {}
  return function (ver, c) {
    let key = ver ? (c ? 'is' + c + 'IE' + ver : 'isIE' + ver ) : 'isIE'
    let v = browser[key]
    if (typeof (v) != 'undefined') {
      return v
    }
    if (!ver) {
      v = (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0)
    } else {
      let match = navigator.userAgent.match(/(?:MSIE |Trident\/.* rv:|Edge\/)(\d+)/)
      if (match) {
        let v1 = parseInt(match[1])
        v = c ? ( c == 'lt' ? v1 < ver : (c == 'gt' ? v1 > ver : undefined)) : v1 == ver
      } else if (ver <= 9) {
        let b = document.createElement('b')
        let s = '<!--[if ' + (c ? c : '') + ' IE ' + ver + ']><i></i><![endif]-->'
        b.innerHTML = s
        v = b.getElementsByTagName('i').length === 1
      } else {
        v = undefined
      }
    }
    browser[key] = v
    return v
  }
}())

tools.checkFileName = (filename) => {
  let match = filename.match(/[\u4e00-\u9fa5a-zA-Z0-9.\-_@]+/)
  return !(!match || match[0] !== filename)

}

tools.escapeHtml = (text) => {
  let map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#039;'
  }
  return text.replace(/[&<>"']/g, function (m) {
    return map[m]
  })
}

tools.ArrayBufferToString = function (buffer) {
  return BinaryToString(String.fromCharCode.apply(null, Array.prototype.slice.apply(new Uint8Array(buffer))))
}

tools.stringToArray = function StringToArrayBuffer (string) {
  return StringToUint8Array(string).buffer
}

function BinaryToString (binary) {
  let error

  try {
    return decodeURIComponent(escape(binary))
  } catch (_error) {
    error = _error
    if (error instanceof URIError) {
      return binary
    } else {
      throw error
    }
  }
}

function StringToBinary (string) {
  let chars, code, i, isUCS2, len, _i

  len = string.length
  chars = []
  isUCS2 = false
  for (i = _i = 0; 0 <= len ? _i < len : _i > len; i = 0 <= len ? ++_i : --_i) {
    code = String.prototype.charCodeAt.call(string, i)
    if (code > 255) {
      isUCS2 = true
      chars = null
      break
    } else {
      chars.push(code)
    }
  }
  if (isUCS2 === true) {
    return unescape(encodeURIComponent(string))
  } else {
    return String.fromCharCode.apply(null, Array.prototype.slice.apply(chars))
  }
}

function StringToUint8Array (string) {
  let binary, binLen, buffer, chars, i, _i
  binary = StringToBinary(string)
  binLen = binary.length
  buffer = new ArrayBuffer(binLen)
  chars = new Uint8Array(buffer)
  for (i = _i = 0; 0 <= binLen ? _i < binLen : _i > binLen; i = 0 <= binLen ? ++_i : --_i) {
    chars[i] = String.prototype.charCodeAt.call(binary, i)
  }
  return chars
}

tools.SortLikeWin = function (v1, v2) {
  if (v1.type === 'tree' && v2.type !== 'tree') return -1
  if (v1.type !== 'tree' && v2.type === 'tree') return 1
  let a = v1.name
  let b = v2.name
  let reg = /[0-9]+/g
  let lista = a.match(reg)
  let listb = b.match(reg)
  if (!lista || !listb) {
    return a.localeCompare(b)
  }
  for (let i = 0, minLen = Math.min(lista.length, listb.length); i < minLen; i++) {
//数字所在位置序号
    let indexa = a.indexOf(lista[i])
    let indexb = b.indexOf(listb[i])
//数字前面的前缀
    let prefixa = a.substring(0, indexa)
    let prefixb = a.substring(0, indexb)
//数字的string
    let stra = lista[i]
    let strb = listb[i]
//数字的值
    let numa = parseInt(stra)
    let numb = parseInt(strb)
//如果数字的序号不等或前缀不等，属于前缀不同的情况，直接比较
    if (indexa !== indexb || prefixa !== prefixb) {
      return a.localeCompare(b)
    }
    else {
//数字的string全等
      if (stra === strb) {
//如果是最后一个数字，比较数字的后缀
        if (i === minLen - 1) {
          return a.substring(indexa).localeCompare(b.substring(indexb))
        }
//如果不是最后一个数字，则循环跳转到下一个数字，并去掉前面相同的部分
        else {
          a = a.substring(indexa + stra.length)
          b = b.substring(indexa + stra.length)
        }
      }
//如果数字的string不全等，但值相等
      else if (numa === numb) {
//直接比较数字前缀0的个数，多的更小
        return strb.lastIndexOf(numb + '') - stra.lastIndexOf(numa + '')
      }
      else {
//如果数字不等，直接比较数字大小
        return numa - numb
      }
    }
  }
}

export default tools
